import React from "react"
import { string, func } from "prop-types"
import styled from "styled-components"

import * as spacings from "styles/spacing"

const Container = styled.input`
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 28px;
  padding-left: ${spacings.xLarge};
  padding-right: 110px;
  font-size: 14px;
  width: 400px;
  border: solid 2px rgba(255, 255, 255, 0);

  ::placeholder {
    color: white;
    opacity: 0.8;
  }

  &:focus {
    border: solid 2px rgba(255, 255, 255, 0.3);
  }
`

const Input = ({ type, onChange, onBlur, value, name, placeholder }) => {
  return (
    <Container
      type={type}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      name={name}
      placeholder={placeholder}
    />
  )
}

Input.propTypes = {
  type: string,
  onChange: func,
  onBlur: func,
  value: string,
  name: string,
  placeholder: string
}

export default Input
